/**
 * Modal-related constants
 */

export const MODAL_BACKDROP_OPACITY = "bg-black/95"; // 95% opacity - twice as opaque as 85%
